import { eventStatusLabels, isEventStatus } from "@sp-crm/core";
import {
    eventAddressSingleLine,
    formatEventStartsAt,
} from "components/events/event-format";
import { EventGuestSummary } from "components/events/event-guest-summary";
import { Panel } from "components/ui/panel/panel";
import { PanelType } from "components/ui/panel/panel-type";
import React from "react";
import { EventCalendarDto } from "./calendar-types";

interface EventDetailPanelProps {
    event: EventCalendarDto;
    onClose: () => void;
}

const Section: React.FC<{ title: string; children: React.ReactNode }> = props => (
    <div>
        <h3 className="text-sm font-medium text-gray-500">{props.title}</h3>
        <div className="mt-1 text-sm text-gray-900">{props.children}</div>
    </div>
);

export const EventDetailPanel: React.FC<EventDetailPanelProps> = ({ event, onClose }) => {
    const address = eventAddressSingleLine(event);
    return (
        <Panel
            isOpen={true}
            type={PanelType.medium}
            headerText={event.title}
            onDismiss={onClose}>
            <div className="space-y-4 p-4">
                <Section title="When">
                    {formatEventStartsAt(event)} · {event.eventDuration} minutes
                </Section>
                {event.location ? (
                    <Section title="Location">{event.location}</Section>
                ) : null}
                {address ? (
                    <Section title="Address">
                        <a
                            className="text-brand-600 hover:text-brand-700"
                            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                address,
                            )}`}
                            target="_blank"
                            rel="noreferrer">
                            {address}
                        </a>
                    </Section>
                ) : null}
                {event.description ? (
                    <Section title="Description">{event.description}</Section>
                ) : null}
                <Section title="Status">
                    {isEventStatus(event.status)
                        ? eventStatusLabels[event.status]
                        : event.status}
                </Section>
                {event.outcome ? (
                    <Section title="Outcome">{event.outcome}</Section>
                ) : null}
                <EventGuestSummary eventId={event.id} />
            </div>
        </Panel>
    );
};
